import React, { Fragment } from 'react'
import {
    Box, Flex
} from '@chakra-ui/react'
import DetailsHeader from '../../component/DetailsHeader'
import RightSidebar from '../../component/RightSidebar'
import Timeline from '../../component/Timeline'
import SettlementInvoice from '../../component/SettlementInvoice'
import AdditionalDetails from '../../component/AdditionalDetails'
import Details from '../../component/Details'




const SettlementDetails = () => {
    return (
        <Fragment>
            <Flex justifyContent={'space-evenly'}>
            <Box p={5} w={'70%'} bgColor='#F5F5F5'>

                <DetailsHeader
                    title={"Settlement ID"}
                    colorScheme={'blackAlpha'}
                    variant={'solid'}
                    invoice={'Create'}
                    menuItems={["Calculated","Raised","Confirmed","Disputed"]}
                    />   
                
                <Details
                    title={"Settlement"}
                    order={"Order Placed"}
                    rent={`₹ 4,000`}
                    btnColorScheme={'pink'}
                    orderDate={"Mar 15, 5:48 PM"}
                    btnText={'Settlement Calculated'}
                    productName={'Product Name'} />


                <AdditionalDetails
                    title={"Settlement"}
                    row1={[{"Tenure ID":`#167846`},{"Order ID":`#167846`},{"Tenure Start Date":`2 January`},{"Tenure End Date":`2 March`}]}
                    row2={[{"Tenure Period":`3 months`},{"Settlement Type":`Minor Damage`},{"Damage Amount":`₹2,000`},{"Settlement Amount":`₹2,0000`}]}
                    status={'Settlement Calculated'} />

                <SettlementInvoice 
                    invoice_details={[{title: 'Security Deposit',title_value: '10% of the total rent',debit: '1,000', credit: '1,000'},
                    {title: 'Minor Damage',title_value: 'Damage in the laptop screen',debit: '', credit: '1,000'},
                    {title: 'Tax',title_value: 'Tax calculated on damage rent',debit: '', credit: '1,000'}]}        
                />

                <Timeline
                text={"Only you and other admin members can see comments"} />
            </Box>
            <Box pr={3} py={3} w={'30%'} bgColor='#F5F5F5'>
                <RightSidebar
                    customerName={'John Doe'}
                    customerGmail={'John@xyz.com'}
                    customerPhone={'9111112225'}
                    shippingArea={'Unkown Area'}
                    shippingCity={'Unkown City'}
                    billingAddress={"Same as shipping address"} />
            </Box>
            </Flex>
        </Fragment>
    )
}

export default SettlementDetails